"use client";

import { c as _c } from "react/compiler-runtime";
type ProgressBarProps = {
  label: string;
  percentage: number;
  voteText?: string;
  className?: string;
};
export default function ProgressBar(t0) {
  const $ = _c(19);
  const {
    label,
    percentage,
    voteText,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `w-[418px] h-auto min-h-[49px] bg-FFFFFF p-2 ${className}`;
  let t3;
  if ($[0] !== label) {
    t3 = <div className="text-12-tamil-400 text-222222 mb-1.5">{label}</div>;
    $[0] = label;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `${Math.min(100, Math.max(0, percentage))}%`;
  let t5;
  if ($[2] !== t4) {
    t5 = {
      width: t4
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== percentage || $[5] !== t5) {
    t6 = <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden"><div className="h-full bg-[#002a63] transition-all duration-500 ease-out" style={t5} role="progressbar" aria-valuenow={percentage} aria-valuemin={0} aria-valuemax={100} /></div>;
    $[4] = percentage;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== percentage) {
    t7 = Math.round(percentage);
    $[7] = percentage;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7 || $[10] !== voteText) {
    t8 = <span className="text-12-tamil-400 text-2D497E whitespace-nowrap">{t7}% {voteText}</span>;
    $[9] = t7;
    $[10] = voteText;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <div className="flex items-center gap-4">{t6}{t8}</div>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t9) {
    t10 = <div className={t2}>{t3}{t9}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}